import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const routers = [
  {
    path: '/',
    meta: {
      title: '高等教育出版社有限公司'
    },
    component: resolve => require(['./views/index.vue'], resolve)
  },
  {
    path: '/course',
    meta: {
      title: '高等教育出版社有限公司'
    },
    component: resolve => require(['./views/course.vue'], resolve)
  },
  {
    path: '/test',
    meta: {
      title: '高等教育出版社有限公司'
    },
    component: resolve => require(['./views/test.vue'], resolve)
  }
]

const RouterConfig = {
  mode: 'hash',
  routes: routers
}

export default new Router(RouterConfig)



// WEBPACK FOOTER //
// ./src/router.js